export const FETCH_FULL_BUILD_EXECUTION_RESULTS = 'FETCH_FULL_BUILD_EXECUTION_RESULTS';
export const FETCH_FULL_BUILD_EXECUTION_RESULTS_SUCCESS = 'FETCH_FULL_BUILD_EXECUTION_RESULTS_SUCCESS';
export const FETCH_FULL_BUILD_EXECUTION_RESULTS_FAILURE = 'FETCH_FULL_BUILD_EXECUTION_RESULTS_FAILURE';

export const FETCH_PR_BUILD_EXECUTION_RESULTS = 'FETCH_PR_BUILD_EXECUTION_RESULTS';
export const FETCH_PR_BUILD_EXECUTION_RESULTS_SUCCESS = 'FETCH_PR_BUILD_EXECUTION_RESULTS_SUCCESS';
export const FETCH_PR_BUILD_EXECUTION_RESULTS_FAILURE = 'FETCH_PR_BUILD_EXECUTION_RESULTS_FAILURE';

export const FETCH_SUITE_RESULTS = 'FETCH_SUITE_RESULTS';
export const FETCH_SUITE_RESULTS_SUCCESS = 'FETCH_SUITE_RESULTS_SUCCESS';
export const FETCH_SUITE_RESULTS_FAILURE = 'FETCH_SUITE_RESULTS_FAILURE';

export const FETCH_CSV_REPORT = 'FETCH_CSV_REPORT';
export const FETCH_CSV_REPORT_SUCCESS = 'FETCH_CSV_REPORT_SUCCESS';
export const FETCH_CSV_REPORT_FAILURE = 'FETCH_CSV_REPORT_FAILURE';

export const SET_SELECTED_EXECUTION = 'SET_SELECTED_EXECUTION';
export const SET_MODAL_OPEN = 'SET_MODAL_OPEN';